module.exports = __webpack_public_path__ + "static/media/jiance.1c5318e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/jiance.svg
// module id = 575
// module chunks = 0